// extracted by mini-css-extract-plugin
export var errormessage = "FormTextInputAutoSuggest-module--errormessage--92d91";
export var formtextinput = "FormTextInputAutoSuggest-module--formtextinput--faf54";
export var formtextinputwithlefticon = "FormTextInputAutoSuggest-module--formtextinputwithlefticon--6002b";
export var iconbutton = "FormTextInputAutoSuggest-module--iconbutton--360da";
export var iconleft = "FormTextInputAutoSuggest-module--iconleft--f7734";
export var iconright = "FormTextInputAutoSuggest-module--iconright--56899";
export var inputwithicon = "FormTextInputAutoSuggest-module--inputwithicon--4bbe6";
export var suggestion = "FormTextInputAutoSuggest-module--suggestion--d9d6f";
export var suggestionbox = "FormTextInputAutoSuggest-module--suggestionbox--d7774";
export var suggestionboxattribution = "FormTextInputAutoSuggest-module--suggestionboxattribution--87804";
export var suggestionboxresults = "FormTextInputAutoSuggest-module--suggestionboxresults--50406";
export var textinputlabel = "FormTextInputAutoSuggest-module--textinputlabel--27312";
export var textinputwrapper = "FormTextInputAutoSuggest-module--textinputwrapper--e3246";